import type { OrderWithItems, OrderStatus } from "../../types";

interface OrderTableProps {
  orders: OrderWithItems[];
  onStatusUpdate: (id: number, status: OrderStatus) => void;
}

export function OrderTable({ orders, onStatusUpdate }: OrderTableProps) {
  const getStatusColor = (status: OrderStatus) => {
    const colors = {
      pending: "bg-yellow-100 text-yellow-800",
      paid: "bg-green-100 text-green-800",
      processing: "bg-blue-100 text-blue-800",
      shipped: "bg-purple-100 text-purple-800",
      delivered: "bg-gray-100 text-gray-800",
      cancelled: "bg-red-100 text-red-800",
    };
    return colors[status] || "";
  };

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-3 text-left">Order #</th>
            <th className="p-3 text-left">Date</th>
            <th className="p-3 text-left">Customer</th>
            <th className="p-3 text-left">Total</th>
            <th className="p-3 text-left">Status</th>
            <th className="p-3 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.id} className="border-b hover:bg-gray-50">
              <td className="p-3 font-mono text-sm">{order.order_number}</td>
              <td className="p-3">
                {new Date(order.created_at).toLocaleDateString()}
              </td>
              <td className="p-3">{order.customer_name}</td>
              <td className="p-3 font-bold">${order.total.toFixed(2)}</td>
              <td className="p-3">
                <span
                  className={`px-2 py-1 rounded text-xs ${getStatusColor(
                    order.status
                  )}`}
                >
                  {order.status}
                </span>
              </td>
              <td className="p-3">
                <select
                  value={order.status}
                  onChange={(e) =>
                    onStatusUpdate(order.id, e.target.value as OrderStatus)
                  }
                  className="border rounded px-2 py-1 text-sm"
                >
                  <option value="pending">Pending</option>
                  <option value="paid">Paid</option>
                  <option value="processing">Processing</option>
                  <option value="shipped">Shipped</option>
                  <option value="delivered">Delivered</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
